/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function LinkOnIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M2 20c0-5.5 4.438-10 10-10h4.5c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5H12c-3.875 0-7 3.188-7 7 0 3.875 3.125 7 7 7h4.5c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5H12A9.95 9.95 0 0 1 2 20m36 0c0 5.563-4.5 10-10 10h-4.5c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5H28c3.813 0 7-3.125 7-7 0-3.812-3.187-7-7-7h-4.5c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5H28c5.5 0 10 4.5 10 10m-24.5-1.5h13c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-13c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5"/>}
        </IconWrapper>);
}
